import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_CANDIDATE_JOB_APPLY_EXPORT_BY_JOBUUID } from "../../../common/URLs";

export const fetchEmployerCandidateJobApplyExportbyJobUuid = async (job_uuid) => {
    try {
        if (!job_uuid) throw new Error("Job UUID is required");

        const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_CANDIDATE_JOB_APPLY_EXPORT_BY_JOBUUID}?job_uuid=${job_uuid}`;
        const token = await fetchToken();
        if (!token) throw new Error("Authentication token not found");

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        // Updated validation to match your API response structure
        if (!data || data.code !== 200 || !Array.isArray(data.response)) {
            throw new Error("Invalid response format - expected array of candidates");
        }

        return {
            success: true,
            response: data.response, // Changed from data.data to data.response
            total: data.response.length,
            message: "Successfully fetched candidates"
        };

    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
};